import * as React from 'react';

import { Badge, BadgeSize } from './Badge';

interface Props {
  color: string;
  className?: string;
  size?: BadgeSize;
}

export const KitIcon: React.FC<Props> = ({ color, className = '' }) => {
  return (
    <Badge
      className={`shadow-inner ${className}`}
      style={{ background: color }}
    ></Badge>
  );
};
